

















import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class ParagraphHeading extends Vue {
  @Prop({ type: Object, default: null }) cms_response!: object;
  data = null;
  heading = {
    heading_margin: "",
    heading_type: "",
    heading_text: ""
  };

  makeHeading(obj: any) {
    this.heading = {
      heading_text: obj.included[0].attributes.field_heading_text,
      heading_type: obj.included[0].attributes.field_heading_type,
      heading_margin:
        "cms__blockContents-u_margin--" +
        obj.included[0].attributes.field_heading_margin
    };
  }

  async created() {
    this.data = this.$props.cms_response;
    await this.makeHeading(this.data);
  }
}
